<div class="container d-flex justify-content-center align-items-center vh-100">
  <div class="card p-4 shadow-sm" style="max-width: 400px; width: 100%;">
    <h3 class="text-center mb-4">Admin Access</h3>
    <div class="mb-3">
      <label class="form-label">Admin Secret</label>
      <input type="password" class="form-control" [(ngModel)]="secret" (keyup.enter)="login()"
        placeholder="Enter secret key">
    </div>
    @if (error) {
      <div class="text-danger mb-3">{{ error }}</div>
    }
    <button class="btn btn-primary w-100" (click)="login()">Access Dashboard</button>
  </div>
</div>